import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import apiFetch from 'utils/apiFetch';
import CloseIconBlue from 'assets/images/CloseIconBlue.svg';
import Faces from 'components/Steps/Faces';
import ThemeTableCard from 'components/Cards/ThemeTableCard';
import SimpleCarousel from 'components/SimpleCarousel';
import UsersModal from 'components/UsersModal';
import Loading from 'components/LoadingComponent';
import { AffiliationModalWrapper } from './styles';

class AffiliationCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: null,
      selectedUser: 0,
      isLoadingConnection: false,
    };
  }

  componentDidMount() {
    const { elementId } = this.props;
    if (elementId) {
      this.loadAffiliationInfo();
    }
  }

  loadAffiliationInfo = () => {
    const { elementId } = this.props;
    const endPoint = `element/${elementId}`;

    apiFetch('GET', { endPoint })
      .then((response) => {
        this.setState({ data: response.data });
      });
  }


  handleClose = () => {
    const { onClose } = this.props;
    onClose();
  }

  goToTable = (tableId) => {
    const { history } = this.props;
    this.handleClose();
    history.push(`/theme-table/${tableId}`);
  }

  doNothing = () => {};

  selectUser = (userId) => {
    this.setState({ selectedUser: userId });
  }

  removeSelectedUser = () => {
    this.setState({ selectedUser: 0 });
  }

  handleConnectWithElement = () => {
    const { connectWithElement } = this.props;
    const { data } = this.state;
    this.setState({ isLoadingConnection: true });
    connectWithElement('affiliation_card', data.element_info)
      .then(() => {
        this.setState({ isLoadingConnection: false });
      })
      .catch(() => {
        this.setState({ isLoadingConnection: false });
      });
  }

  handleRemoveConnectionWithElement = () => {
    const { removeConnectionWithElement } = this.props;
    const { data } = this.state;
    this.setState({ isLoadingConnection: true });
    removeConnectionWithElement('affiliation_card', data.element_info)
      .then(() => {
        this.setState({ isLoadingConnection: false });
      })
      .catch(() => {
        this.setState({ isLoadingConnection: false });
      });
  }

  printPeople = () => {
    const { data } = this.state;
    const { literals } = this.props;


    const title = `${data.users.length} ${literals.people}`;
    const people = (
      <div className='users'>
        <SimpleCarousel classesList='face_bubble'>
          <Faces
            options={data.users}
            onClick={this.selectUser}
            onLongPress={this.selectUser}
          />
        </SimpleCarousel>
      </div>
    );
    return (
      <React.Fragment>
        <div className='title'>
          {title}
        </div>
        {people}
      </React.Fragment>
    );
  }

  printTables = () => {
    const { data } = this.state;
    const { literals, app, user } = this.props;

    const tables = data.tables.map((table) => {
      return (
        <ThemeTableCard onClick={this.goToTable} data={table} key={table.id} app={app} user={user} />
      );
    });

    const title = `${data.tables.length} ${literals.tables}`;

    return (
      <React.Fragment>
        <div className='title'>
          {title}
        </div>
        <SimpleCarousel classesList='theme_table_card'>
          {tables}
        </SimpleCarousel>
      </React.Fragment>
    );
  }

  printSelectedUser = () => {
    const { selectedUser, data } = this.state;

    if (!selectedUser) {
      return null;
    }

    return (
      <UsersModal
        usersIds={_.map(data.users, user => user.id)}
        userSelected={selectedUser}
        onEnd={this.removeSelectedUser}
      />
    );
  }


  render() {
    const { literals, open, userElements } = this.props;
    const { data, selectedUser, isLoadingConnection } = this.state;

    if (selectedUser) {
      return this.printSelectedUser();
    }

    if (data) {
      const hasThisElement = _.find(userElements, { id: data.element_info.id });
      let buttonBelong = null;
      if (!isLoadingConnection) {
        if (hasThisElement) {
          buttonBelong = (<button type='button' className='btn_dont_belong' onClick={this.handleRemoveConnectionWithElement}>{literals.alreadyBelong}</button>);
        } else {
          buttonBelong = (<button type='button' className='btn_belong' onClick={this.handleConnectWithElement}>{literals.belong}</button>);
        }
      }
      return (
        <React.Fragment>
          <AffiliationModalWrapper
            open={open}
            onClose={this.handleClose}
            aria-labelledby='simple-modal-title'
            aria-describedby='simple-modal-description'
          >
            <div className='modal affiliation_card'>
              <button type='button' onClick={this.handleClose}>
                <img src={CloseIconBlue} alt='' />
              </button>

              <div className='affiliation_info'>
                <div className='icon' style={{ backgroundImage: `url(${data.element_info.image})` }} />
                <div className='info'>
                  <p>{data.element_info.name}</p>
                  <a href={data.element_info.description} target='_blank' rel='noopener noreferrer'>{data.element_info.description}</a>
                  {buttonBelong}
                </div>
              </div>
              <div className='sponsor'>{literals.peopleAndTables}</div>
              <div className='people'>
                {this.printPeople()}
              </div>
              {data.tables.length ? (
                <div className='tables'>
                  {this.printTables()}
                </div>
              ) : null}
            </div>
          </AffiliationModalWrapper>
        </React.Fragment>
      );
    }

    return (
      <AffiliationModalWrapper
        open={open}
        onClose={this.handleClose}
        aria-labelledby='simple-modal-title'
        aria-describedby='simple-modal-description'
      >
        <div className='modal affiliation_card'>
          <button type='button' onClick={this.handleClose}>
            <img src={CloseIconBlue} alt='' />
          </button>
          <Loading />
        </div>
      </AffiliationModalWrapper>
    );
  }
}

AffiliationCard.propTypes = {
  literals: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  elementId: PropTypes.number.isRequired,
  connectWithElement: PropTypes.func.isRequired,
  removeConnectionWithElement: PropTypes.func.isRequired,
  userElements: PropTypes.array,
};

AffiliationCard.defaultProps = {
  userElements: [],
};

export default AffiliationCard;



// WEBPACK FOOTER //
// ./src/components/AffiliationCard/components/index.jsx